module.exports = __webpack_public_path__ + "static/media/frandre.b19d7150.png";